import React from "react";

import { useDispatch } from "react-redux";
import {
  Button,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  Grid,
  Typography,
  FormControl,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { round } from "lodash";
import { useSnackbar } from "notistack";
import { dollarStringOptions, ERRORS_MESSAGE } from "../../constants";
import { sendDisclosure } from "../../store/slices/applicationFormSlice";
import { isValidNumberWithDecimalInput } from "../Utils/helperFunction";

const BmaSendDisclosure = ({
  productDetails,
  application,
  handleOpenDisclosureDialog,
  handleCloseDisclosureDialog,
  disclosureFields,
  setDisclosureFields,
  openDisclosureDialog,
  updateDisclosureRate,
  loanDetails,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handle = {
    onChangeField: (value, name) => {
      let isValid = true

      if (value === "") {
        setDisclosureFields({
          ...disclosureFields,
          [name]: "",
        });
        return;
      }

      if (
        name === "originationFee" ||
        name === "inspectionFee" ||
        name === "registrationFee" ||
        name === "applicationFee" ||
        name === "referralFee" ||
        name === "accountFee"
      ) {
        isValid = isValidNumberWithDecimalInput(value)
      }

      if (isValid) {
        setDisclosureFields({
          ...disclosureFields,
          [name]: value,
        });
      }
    }
  }
  // const handle = {
  //   saveQuote: async () => {
  //     if (loanDetails?._id)
  //       await dispatch(
  //         updateLoanDetails(
  //           merge({
  //             ...loanDetails,
  //             ...{
  //               loanAmount: productDetails?.loanAmount,
  //               rate: productDetails?.rate,
  //               repayments: productDetails?.repayments,
  //               brokerage: productDetails?.brokerage,
  //               // fees: handleFees(),
  //             },
  //           }),
  //         ),
  //       ).unwrap();
  //   },
  // };

  return (
    <React.Fragment>
      <Dialog open={openDisclosureDialog} onClose={handleCloseDisclosureDialog}>
        <DialogTitle>Send Proposal Disclosure Statement</DialogTitle>
        <DialogContent>
          <DialogContentText>Please review and update the details below.</DialogContentText>
          <Stack direction="column">
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Indicative rate"
              variant="outlined"
              value={disclosureFields.rate}
              onChange={(e) => {
                // setDisclosureFields({
                //   ...disclosureFields,
                //   rate: e.target.value,
                // });
                updateDisclosureRate({ rate: e.target.value });
              }}
            />
            {/* <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Indicative monthly repayment"
              variant="outlined"
              value={disclosureFields.repayments}
              onChange={(e) => {
                setDisclosureFields({
                  ...disclosureFields,
                  repayments: e.target.value,
                });
              }}
            /> */}
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Origination fee"
              variant="outlined"
              value={disclosureFields.originationFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "originationFee")
                // setDisclosureFields({
                //   ...disclosureFields,
                //   originationFee: e.target.value,
                // });
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Inspection fee"
              variant="outlined"
              value={disclosureFields.inspectionFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "inspectionFee")
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Application fee"
              variant="outlined"
              value={disclosureFields.applicationFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "applicationFee")
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              id="rate"
              label="Asset registration fee"
              variant="outlined"
              value={disclosureFields.registrationFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "registrationFee")
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Lender monthly account keeping fee"
              variant="outlined"
              value={disclosureFields.accountFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "accountFee")
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Referral fee"
              variant="outlined"
              value={disclosureFields.referralFee}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "referralFee")
              }}
            />
            <TextField
              autoFocus
              margin="dense"
              size="small"
              label="Referrer"
              variant="outlined"
              value={disclosureFields.referrer}
              onChange={(e) => {
                handle.onChangeField(e.target.value, "referrer")
              }}
            />

            <FormControl component="fieldset" variant="standard" sx={{ mt: 1 }}>
              <FormControlLabel
                control={
                  <Switch
                    onChange={(event) => {
                      updateDisclosureRate({ rate: disclosureFields?.rate?.toString(), inArrears: event.target?.checked ? "Yes" : "No" });
                    }}
                    checked={disclosureFields?.inArrears === "Yes" ? true : false}
                    name={"In arrears"}
                    size="small"
                    sx={{ ml: 1 }}
                  />
                }
                label={"In arrears"}
              />
            </FormControl>

            {/* Repayments */}
            <Grid item sm={12} spacing={1} direction="row" style={{ margin: "15px 0px 0px 0px" }}>
              <Typography
                sx={{ display: "inline" }}
                variant="body2"
                style={{
                  marginRight: "5px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" fontWeight={"bold"}>
                  Repayments:
                </Typography>
                <span>{disclosureFields?.repayments?.toLocaleString("en-US", dollarStringOptions) || "0"}/Mth</span>
              </Typography>

              <Typography
                sx={{ display: "inline" }}
                variant="body2"
                style={{
                  marginRight: "5px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="body2" fontWeight={"bold"}>
                  Effective Rate:
                </Typography>
                <span>{(1 * disclosureFields?.effectiveRate).toFixed(2)}%</span>
              </Typography>
            </Grid>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisclosureDialog}>Cancel</Button>
          <Button
            onClick={() => {
              handleCloseDisclosureDialog();
              dispatch(
                sendDisclosure({
                  ...disclosureFields,
                  ...{
                    applicationId: application._id,
                    lenderType: productDetails?.lender,
                    effectiveRate: round(disclosureFields?.effectiveRate, 2),
                    rate: +disclosureFields?.rate,
                  },
                }),
              ).then((res) => {
                if (res?.payload?.data) {
                  enqueueSnackbar(res?.payload?.data?.status_message, {
                    variant: "success",
                    autoHideDuration: 5000,
                  });
                } else {
                  enqueueSnackbar(ERRORS_MESSAGE.fetchErrorMsg, {
                    variant: "error",
                    autoHideDuration: 5000,
                  });
                }
              });
            }}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default BmaSendDisclosure;